export const ACTIVE_OPENAI_MODELS = [
  { id: "gpt-5.6-luna", label: "GPT-5.6 Luna", profile: "alto volume e tarefas objetivas" },
  { id: "gpt-5.6-terra", label: "GPT-5.6 Terra", profile: "equilíbrio entre qualidade e custo" },
  { id: "gpt-5.6-sol", label: "GPT-5.6 Sol", profile: "análises complexas e maior precisão" },
] as const;

export const ACTIVE_OPENAI_MODEL_IDS = ACTIVE_OPENAI_MODELS.map((model) => model.id);
export const DEFAULT_OPENAI_MODEL = "gpt-5.6-terra";
export const OPENAI_REASONING_EFFORT = "high";

/** Set VITE_AI_PROVIDER_MODE=multi to restore preserved legacy provider UI. */
export const OPENAI_ONLY_MODE = import.meta.env.VITE_AI_PROVIDER_MODE !== "multi";

export function normalizeAdminModelPriority(priority: string[] | null | undefined): string[] {
  if (!OPENAI_ONLY_MODE) return priority?.length ? priority : [DEFAULT_OPENAI_MODEL];
  const active = priority?.find((model) => ACTIVE_OPENAI_MODEL_IDS.includes(model));
  return [active ?? DEFAULT_OPENAI_MODEL];
}
